// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__pX9Zg","img":"Image_img__Z4zRs","skeleton":"Image_skeleton__YJ9-T"};